import CloseVacancyModal from './CloseVacancyModal.component';

export default CloseVacancyModal;
